import { render, staticRenderFns } from "./account-takeover.vue?vue&type=template&id=0e5ccc66&"
import script from "./account-takeover.vue?vue&type=script&lang=js&"
export * from "./account-takeover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports